import { GET_CATEGORIES ,GET_CITY } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_CATEGORIES:
            return action.payload;
        case GET_CITY:
            return action.payload;
        default:
            return state;
    }
}
